import { Box, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { Link } from 'react-router-dom';

import FaqIcon from 'common/shared-ui/src/icons/FaqIcon';
import NotificationIcon from 'common/shared-ui/src/icons/NotificationIcon';

// Original class: HeaderIconsRoot
const StyledHeaderIconsRoot = styled(Box)(({ theme }) => ({
  marginLeft: '32px',
  marginRight: theme.spacing(8),

  [theme.breakpoints.down('sm')]: {
    marginRight: 0,
  },
}));
// Original class: icon
const StyledIcon = styled(Link, {
  shouldForwardProp: prop => !['notificationIconStyle'].includes(prop),
})(({ theme, notificationIconStyle }) => ({
  width: 32,
  height: 32,
  padding: theme.spacing(1),
  '& svg': {
    fill: '#fff',
    width: '100%',
    height: '100%',
  },
  ...(notificationIconStyle && {
    marginRight: theme.spacing(2),

    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
    },
  }),
}));

const HeaderNavIcons = () => {
  const isSmallScreen = useMediaQuery(theme =>
    theme.breakpoints.maxWidth('sm'),
  );
  return (
    <StyledHeaderIconsRoot
      sx={{
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
      }}
    >
      <StyledIcon to='/' notificationIconStyle={true}>
        <NotificationIcon viewBox='0 0 24 24' />
      </StyledIcon>
      {!isSmallScreen && (
        <StyledIcon
          target={'_blank'}
          to={
            'https://xwiki.rbdata.group/wiki/usermanual/view/Main/%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D1%81%D0%BA%D0%B0%D1%8F%20%D0%B4%D0%BE%D0%BA%D1%83%D0%BC%D0%B5%D0%BD%D1%82%D0%B0%D1%86%D0%B8%D1%8F%201/'
          }
        >
          <FaqIcon viewBox='0 0 24 24' />
        </StyledIcon>
      )}
    </StyledHeaderIconsRoot>
  );
};

export default HeaderNavIcons;
